// src/pages/Settings/index.jsx
// STATUS: stable | UPDATED: 2026-08-02
// LOG:
//   2026-08-02  Header standardized; Phase 1 checkpoint committed (e765830).
//   2026-07-23  Full settings page: password, email, sessions, logout
// Account settings. Reached from the avatar menu. Clean black theme.
//
// Sections:
//   Account     read-only identity (name, username, email, role, dealership)
//   Password    change password, requires the current password
//   Email       change email, unlocked by entering the current password first
//   Session     sign out
//
// The "unlock" pattern on email: a walk-up cannot change the email of a
// logged-in session. The user must re-enter their password to unlock it.

import { VStack, Box, Heading, Text } from '@chakra-ui/react'
import { useAuth } from '../../hooks/useAuth'
import AccountSection from './components/AccountSection.jsx'
import AppearanceSection from './components/AppearanceSection.jsx'
import CoachMemorySection from './components/CoachMemorySection.jsx'
import PasswordSection from './components/PasswordSection.jsx'
import EmailSection from './components/EmailSection.jsx'
import SessionSection from './components/SessionSection.jsx'

export default function Settings() {
  const { user, profile, dealership, role } = useAuth()

  return (
    <VStack align="stretch" spacing={10} maxW="sheet">
      <Box>
        <Text textStyle="pageEyebrow" mb={1}>
          Account
        </Text>
        <Heading textStyle="pageTitle">
          Settings
        </Heading>
      </Box>

      <AccountSection profile={profile} user={user} dealership={dealership} role={role} />
      <CoachMemorySection />
      <AppearanceSection />
      <PasswordSection />
      <EmailSection currentEmail={user?.email} />
      <SessionSection />
    </VStack>
  )
}